











































































































































































































































































































































































































import BaseComponent from '@/core/base.component';
import {
  AdminDto,
  AdminListDto,
  AdminSendMessageDto,
  BrandDto,
  BrandListDto,
  ProductConsultDto,
  ProductConsultUpdateDto,
} from '@/dto';
import ProductConsultService from '@/services/product-consult.service';
import { APPROVAL_STATUS, PRODUCT_CONSULT } from '@/services/shared';
import { Component, Vue } from 'vue-property-decorator';
import { getStatusColor } from '@/core/utils/status-color.util';
import SmsService from '@//services/sms.service';
import toast from '../../../../resources/assets/js/services/toast.js';
import { BaseUser } from '@/services/shared/auth';
import AdminService from '@/services/admin.service';
import { CONST_YN, Pagination, YN } from '@/common';
import { CodeManagementDto } from '@/services/init/dto';
import BrandService from '@/services/brand.service';
import CodeManagementService from '@/services/code-management.service';

@Component({
  name: 'ProductConsultDetail',
})
export default class ProductConsultDetail extends BaseComponent {
  private productConsultDto = new ProductConsultDto();
  private adminSendMessageDto = new AdminSendMessageDto();
  private confirmDate = new Date();
  private productConsultUpdateDto = new ProductConsultUpdateDto();
  private selectedAdmin: AdminDto = new AdminDto(BaseUser);
  private adminList: AdminDto[] = [];
  private adminListDto = new AdminListDto();
  private adminListCount = null;
  private pagination = new Pagination();
  private expYn: YN[] = [...CONST_YN];
  private statusSelect: CodeManagementDto[] = [];
  private genderSelect: CodeManagementDto[] = [];
  private brandDto = new BrandListDto();
  private brandList: BrandDto[] = [];

  // get status color
  getStatusColor(status: PRODUCT_CONSULT) {
    return getStatusColor(status);
  }

  // get product consult codes
  getProductConsultCodes() {
    CodeManagementService.findAnyCode('PRODUCT_CONSULT').subscribe(res => {
      this.statusSelect = res.data;
    });
  }

  // 성별
  getGender() {
    CodeManagementService.findAnyCode('GENDER').subscribe(res => {
      this.genderSelect = res.data;
    });
  }

  assignYourselfAdmin() {
    ProductConsultService.assignAdmin(this.productConsultDto.no).subscribe(
      res => {
        this.findOne(this.productConsultDto.no);
      },
    );
  }

  findOne(id) {
    ProductConsultService.findOne(id).subscribe(res => {
      if (res) {
        BrandService.findNanudaBrand().subscribe(res => {
          this.brandList = res.data;
        });
        this.productConsultDto = res.data;
        this.getProductConsultCodes();
      }
    });
  }

  // 문자 전송
  sendMessage() {
    this.adminSendMessageDto.phone = this.productConsultDto.nanudaUser.phone;
    SmsService.sendMessage(this.adminSendMessageDto).subscribe(res => {
      if (res) {
        this.adminSendMessageDto = new AdminSendMessageDto();
        toast.success('문자가 발송 되었습니다.');
      } else {
        return;
      }
    });
  }
  // update Nanuda User
  updateNanudaUser() {
    if (this.productConsultDto.nanudaUser.gender) {
      this.productConsultUpdateDto.gender = this.productConsultDto.nanudaUser.gender;
    }
    this.getGender();
  }

  // show update modal
  showUpdateModal() {
    this.productConsultUpdateDto = this.productConsultDto;
    this.getProductConsultCodes();
    this.findOne(this.$route.params.id);
  }

  // update product consult
  updateProductConsult() {
    if (this.selectedAdmin) {
      this.productConsultDto.pConsultManager = this.selectedAdmin.no;
    }
    if (this.confirmDate) {
      this.productConsultDto.confirmDate = this.confirmDate;
    }

    ProductConsultService.update(
      this.productConsultDto.no,
      this.productConsultDto,
    ).subscribe(res => {
      if (res) {
        toast.success('수정완료');
        this.findOne(this.productConsultDto.no);
      }
    });
  }

  clearOutUpdateDto() {
    this.productConsultUpdateDto = new ProductConsultDto();
  }

  // 관리자 수정
  selectAdmin(admin: AdminDto) {
    this.selectedAdmin = admin;
  }

  cancelSelection() {
    this.selectedAdmin = new AdminDto(BaseUser);
  }

  findAdmin(isPagination: boolean) {
    if (!isPagination) {
      this.pagination.page = 1;
    }
    this.pagination.limit = 5;
    AdminService.findAll(this.adminListDto, this.pagination).subscribe(res => {
      this.adminList = res.data.items;
      this.adminListCount = res.data.totalCount;
    });
  }

  paginateSearch() {
    this.findAdmin(true);
  }

  created() {
    const id = this.$route.params.id;
    this.findOne(id);
  }
}
